/* global DEV_ENV */
import App from './App.svelte';
import * as Sentry from '@sentry/svelte';

// eslint-disable-next-line no-constant-condition
if (false) {
  if (!DEV_ENV) {
    Sentry.init({
      dsn: 'https://fbb20f2282b744002c594af8c262df81@o4505846224453632.ingest.sentry.io/4505846241165312',
      integrations: [
        new Sentry.BrowserTracing({
          tracePropagationTargets: [
            /^https:\/\/www\.eurobaseball2023\.com\/api/,
            /^https:\/\/www\.praguebaseballweek\.eu\/api/,
            /^https:\/\/europe\.nede\.cz\/api/,
          ],
        }),
        new Sentry.Replay(),
      ],
      tracesSampleRate: 0.05,
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
    });
  }
}

// eslint-disable-next-line no-new
new App({ target: document.querySelector('#spa') });
